import { render, staticRenderFns } from "./galeries.vue?vue&type=template&id=3928c014&"
import script from "./galeries.vue?vue&type=script&lang=js&"
export * from "./galeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports